import { useLoginContext } from "../../../App";

const useRolesAndProductsCheck = () => {
    const { loginData } = useLoginContext() || {};
    
    const checkRolesPresence = (rolesToCheck) => {
        if (!rolesToCheck || rolesToCheck.length === 0) return true;
        const check =
            (loginData?.roles?.includes('ROLE_SUPER_ADMIN') || loginData?.roles?.includes('SUPER_ADMIN')) ||
            (rolesToCheck.some(role => loginData?.roles?.includes(role) || loginData?.roles?.includes('ROLE_' + role)));
        return check;
    };

    const checkProductsPresence = (productsToCheck) => {
        if (!productsToCheck || productsToCheck.length === 0) return true;
        const check = productsToCheck.some(product => loginData?.productAcronyms?.includes(product));
        return check;
    };

    const checkRolesAndProductsPresence = (rolesToCheck, productsToCheck) => {
        const rolesCheck = checkRolesPresence(rolesToCheck);
        const productsCheck = checkProductsPresence(productsToCheck);
        return rolesCheck && productsCheck;
    };

    return {
        checkRolesPresence,
        checkProductsPresence,
        checkRolesAndProductsPresence,
    };
    
}

export default useRolesAndProductsCheck;